import { CerebroDrawer } from '../../../shared/components';
import { TermSheetFacility } from '../../../shared/models';
import { FacilityForm } from './FacilityForm';

interface EditFacilityDrawerProps {
	dataRoomGuid: string | undefined;
	termSheetGuid: string | undefined;
	revisionGuid: string | undefined;
	facility: TermSheetFacility | null;
	close: () => void;
}

export const EditFacilityDrawer: React.FC<EditFacilityDrawerProps> = ({
	dataRoomGuid,
	termSheetGuid,
	revisionGuid,
	facility,
	close,
}) => {
	return (
		<CerebroDrawer open={facility != null} onClose={close}>
			<FacilityForm
				dataRoomGuid={dataRoomGuid}
				termSheetGuid={termSheetGuid}
				revisionGuid={revisionGuid}
				facility={facility}
				close={close}
			/>
		</CerebroDrawer>
	);
};
